<template>
  <section class="page-section" v-loading="pageLoading">
    <el-form
      size="small"
      ref="formData"
      :model="formData"
      label-width="150px"
      class="content-form"
    >
      <!-- 基本信息 -->
      <div class="form-module">
        <div class="module-header">客户信息</div>
        <div class="module-body">
          <el-form-item label="姓名" required :show-message="false">
            <el-input
              v-model="formData.customerName"
              class="w240"
              maxlength="50"
              :disabled="disabled"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" required :show-message="false">
            <el-select v-model="formData.sex" class="w240">
              <el-option :value="1" label="男"></el-option>
              <el-option :value="0" label="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生日" :show-message="false">
            <el-date-picker
              v-model="formData.birthday"
              class="w240"
              type="date"
              format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="年龄" required :show-message="false">
            <el-input
              v-model="formData.age"
              class="w240"
              maxlength="50"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" required :show-message="false">
            <el-input
              v-model="formData.mobile"
              class="w240"
              maxlength="50"
              :disabled="disabled"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="预约项目" required :show-message="false">
            <el-select
              v-model="formData.serviceId"
              filterable
              clearable
              :loading="serviceOptionsLoading"
              :disabled="disabled"
              placeholder="请选择"
              class="w240"
            >
              <el-option
                v-for="(row, rowIndex) in serviceOptions"
                :key="rowIndex"
                :label="row.name"
                :value="row.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="价格" required :show-message="false">
            <el-input
              v-model="formData.price"
              class="w240"
              maxlength="50"
              :disabled="disabled"
              placeholder=""
            >
              <template slot="prepend">￥</template>
            </el-input>
          </el-form-item>
          <el-form-item label="预约时间" required :show-message="false">
            <el-date-picker
              v-model="formData.orderTime"
              class="w240"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="预约门店" required :show-message="false">
            <el-select
              v-model="formData.shopId"
              filterable
              clearable
              :loading="shopOptionsLoading"
              placeholder="请选择"
              class="w240"
            >
              <el-option
                v-for="(row, rowIndex) in shopOptions"
                :key="rowIndex"
                :label="row.name"
                :value="row.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他要求" :show-message="false">
            <el-input
              type="textarea"
              :rows="4"
              v-model="formData.remark"
              class="w240"
              :disabled="disabled"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <!-- 微信沟通记录 -->
      <div class="form-module">
        <div class="module-header">微信沟通记录</div>
        <div class="module-body">
          <el-table
            size="small"
            :data="chatsList"
            ref="multipleTable"
            style="width: 700px"
          >
            <el-table-column label="时间" width="200">
              <template slot-scope="scope">
                <p>{{ COMMON.formatDate("3", "-", scope.row.chatTime) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="内容" width="300">
              <template slot-scope="scope">
                <p>{{ scope.row.content }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="165"
                  v-model="scope.row.deleteVisible"
                  popper-class="confirm-popover"
                >
                  <p>确定删除该记录？</p>
                  <div>
                    <el-button
                      size="small"
                      type="default"
                      plain
                      @click="scope.row.deleteVisible = false"
                      >取消</el-button
                    >
                    <el-button
                      size="small"
                      type="primary"
                      @click="handleChatsDelete(scope.row, scope.$index)"
                      :loading="scope.row.deleteLoading"
                      >确定</el-button
                    >
                  </div>

                  <el-button size="small" type="text" slot="reference"
                    >删除</el-button
                  >
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            type="primary"
            size="small"
            style="margin-top: 10px"
            @click="handleChatsAdd"
            >添加沟通记录</el-button
          >
        </div>
      </div>

      <!-- 预计消费 -->
      <div class="form-module">
        <div class="module-header">预计消费</div>
        <div class="module-body">
          <el-form-item label="预计消费" :show-message="false">
            <el-input
              type="number"
              v-model="formData.expectedSpending"
              class="w240"
              maxlength="50"
              placeholder=""
            ></el-input>
            <span style="margin-left: 5px">韩币</span>
          </el-form-item>
        </div>
      </div>

      <!-- 行程信息 -->
      <div class="form-module">
        <div class="module-header">行程信息</div>
        <div class="module-body">
          <el-form-item label="护照" :show-message="false">
            <el-input
              v-model="formData.passport"
              class="w240"
              maxlength="50"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="国籍" :show-message="false">
            <el-input
              v-model="formData.country"
              class="w240"
              maxlength="50"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="航班" :show-message="false">
            <el-input
              v-model="formData.flight"
              class="w240"
              maxlength="50"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="赴韩时间" :show-message="false">
            <el-date-picker
              v-model="formData.fromTime"
              class="w240"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="落地时间" :show-message="false">
            <el-date-picker
              v-model="formData.toTime"
              class="w240"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="入驻酒店" :show-message="false">
            <el-input
              v-model="formData.hotel"
              class="w240"
              maxlength="50"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="入驻时间" :show-message="false">
            <el-date-picker
              v-model="formData.stayTime"
              class="w240"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="接机" :show-message="false">
            <el-radio-group v-model="formData.needPickup">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>

      <!-- 医美经历 -->
      <div class="form-module">
        <div class="module-header">医美经历</div>
        <div class="module-body">
          <el-form-item label="" :show-message="false" label-width="10px">
            <el-input
              type="textarea"
              :rows="8"
              v-model="formData.medicalExperience"
              class="w500"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <!-- 诊疗记录 -->
      <div class="form-module">
        <div class="module-header">诊疗记录</div>
        <div class="module-body">
          <el-form-item label="" :show-message="false" label-width="10px">
            <el-input
              type="textarea"
              :rows="8"
              v-model="formData.diagnosisRecord"
              class="w500"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <!-- 重要事项 -->
      <div class="form-module">
        <div class="module-header">重要事项</div>
        <div class="module-body">
          <el-form-item label="" :show-message="false" label-width="10px">
            <el-input
              type="textarea"
              :rows="8"
              v-model="formData.importantMatters"
              class="w500"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <!-- 特殊要求 -->
      <div class="form-module">
        <div class="module-header">特殊要求</div>
        <div class="module-body">
          <el-form-item label="" :show-message="false" label-width="10px">
            <el-input
              type="textarea"
              :rows="8"
              v-model="formData.specialRequirements"
              class="w500"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="form-button-wrap">
        <el-button type="default" size="small" @click="handleback"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="handleFormSubmit('formData')"
          >保存</el-button
        >
      </div>
    </el-form>

    <!-- 添加沟通记录 -- 弹窗 -->
    <el-dialog
      title="添加沟通记录"
      :visible.sync="formDialog.visible"
      width="400px"
    >
      <el-form
        size="small"
        ref="formDialog"
        :model="formDialog"
        label-width="50px"
        class="dialog-form"
        :rules="formDialog.rules"
      >
        <el-form-item label="时间" prop="chatTime" style="margin-bottom: 20px">
          <el-date-picker
            v-model="formDialog.chatTime"
            class="w310"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            class="text-area"
            type="textarea"
            :rows="4"
            v-model="formDialog.content"
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="formDialog.visible = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="handleChatsSave('formDialog')"
          :loading="formDialog.saveLoading"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import {
  COMMON,
  serviceManageList,
  serviceShopList,
  serviceOrdersDetail,
  serviceOrdersUpdateOrderInfo,
  serviceChatsList,
  serviceChatsSave,
  serviceChatsDelete,
  serviceChatsGetSchedule,
  serviceChatsAddSchedule,
} from "@/common/api";

export default {
  name: "serviceReservationAdd",
  data() {
    return {
      COMMON,

      id: this.$route.query.id || "",
      tabName: this.$route.query.tabname || "",
      pageLoading: true,

      disabled: true,

      formData: {
        // 表单数据
        customerName: "",
        sex: 1,
        birthday: "",
        age: "",
        mobile: "",
        serviceId: "",
        price: "",
        orderTime: "",
        shopId: "",
        remark: "",

        expectedSpending: "",

        scheduleId: null,
        passport: "",
        country: "",
        flight: "",
        fromTime: "",
        toTime: "",
        hotel: "",
        stayTime: "",
        needPickup: 1,

        medicalExperience: "",
        diagnosisRecord: "",
        importantMatters: "",
        specialRequirements: "",
      },

      chatsList: [],
      formDialog: {
        visible: false,
        chatTime: "",
        content: "",
        saveLoading: false,
        rules: {
          chatTime: [
            { required: true, message: "请选择时间", trigger: "blur" },
          ],
          content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        },
      },

      serviceOptionsLoading: true,
      serviceOptions: [],

      shopOptionsLoading: true,
      shopOptions: [],

      submitLoading: false,
    };
  },
  mounted() {
    this.getShopList();
    this.getServiceList();
    this.getChatsList();
    this.getChatsSchedule();
    this.getDetail();
  },
  methods: {
    /**
     * [getServiceList description] 获取服务列表
     * @return {[type]}         [description]
     */
    getServiceList: function () {
      this.serviceOptionsLoading = true;

      let params = {
        current: 1,
        size: 9999,
      };

      serviceManageList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.serviceOptions = data.records || [];
          this.serviceOptionsLoading = false;
        }
      });
    },
    /**
     * [getShopList description] 获取门店列表
     * @return {[type]}         [description]
     */
    getShopList: function () {
      this.shopOptionsLoading = true;

      let params = {
        name: "",
        status: "",
        pageNo: 1,
        pageSize: 9999,
      };

      serviceShopList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.shopOptions = data.records || [];
          this.shopOptionsLoading = false;
        }
      });
    },
    /**
     * [getChatsList description] 获取微信沟通记录列表
     * @return {[type]}         [description]
     */
    getChatsList() {
      let params = {
        orderId: this.id,
      };

      serviceChatsList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.chatsList = data || [];
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * [getChatsSchedule description] 获取行程信息及后四项
     * @return {[type]}         [description]
     */
    getChatsSchedule() {
      let params = {
        orderId: this.id,
      };

      serviceChatsGetSchedule(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          if (data) {
            Object.assign(this.formData, {
              scheduleId: data.id || null,
              expectedSpending: data.expectedSpending || "",
              passport: data.passport || "",
              country: data.country || "",
              flight: data.flight || "",
              fromTime: data.fromTime || "",
              toTime: data.toTime || "",
              hotel: data.hotel || "",
              stayTime: data.stayTime || "",
              needPickup: data.needPickup,

              medicalExperience: data.medicalExperience || "",
              diagnosisRecord: data.diagnosisRecord || "",
              importantMatters: data.importantMatters || "",
              specialRequirements: data.specialRequirements || "",
            });
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * [getDetail description] 获取详情
     * @return {[type]} [description]
     */
    getDetail: function () {
      this.pageLoading = true;

      let params = {
        orderId: this.id,
      };

      serviceOrdersDetail(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.pageLoading = false;

            Object.assign(this.formData, {
              customerName: data.customerName || "",
              sex: data.sex || 0,
              birthday: data.birthday || "",
              age: data.age || "",
              mobile: data.mobile || "",
              serviceId: data.serviceId || "",
              price: data.price || "",
              orderTime: data.orderTime || "",
              shopId: data.shopId || "",
              remark: data.remark || "",
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("服务器异常");
        });
    },
    /**
     * 添加微信沟通记录
     */
    handleChatsAdd() {
      Object.assign(this.formDialog, {
        visible: true,
        chatTime: "",
        content: "",
        saveLoading: false,
      });
      this.$nextTick(() => {
        this.$refs.formDialog.clearValidate();
      });
    },
    /**
     * 添加微信沟通记录 - 保存
     */
    handleChatsSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formDialog.saveLoading = true;

          let params = {
            orderId: this.id,
            chatTime: this.formDialog.chatTime
              ? new Date(this.formDialog.chatTime).getTime()
              : "",
            content: this.formDialog.content,
          };

          serviceChatsSave(params)
            .then((res) => {
              this.formDialog.saveLoading = false;

              let { code, data, msg } = res;

              if (code == 0) {
                this.$message({ message: "保存成功", type: "success" });
                this.formDialog.visible = false;
                this.getChatsList();
              } else {
                this.$message.error(msg);
              }
            })
            .catch((error) => {
              this.formDialog.saveLoading = false;
              this.$message.error("服务器异常");
            });
        } else {
          return false;
        }
      });
    },
    /**
     * 删除微信沟通记录
     */
    handleChatsDelete(row, index) {
      row.deleteLoading = true;
      this.$set(this.chatsList, index, row);

      let params = {
        id: row.id,
      };

      serviceChatsDelete(params)
        .then((res) => {
          row.deleteLoading = false;
          this.$set(this.chatsList, index, row);

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message({ message: "删除成功", type: "success" });
            this.chatsList.splice(index, 1);
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          row.deleteLoading = false;
          this.$set(this.chatsList, index, row);
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleback description] 取消-返回列表
     * @return {[type]}          [description]
     */
    handleback: function () {
      this.$router.push("/service/reservation/list");
    },
    /**
     * [handleFormSubmit description] 保存数据
     * @return {[type]} [description]
     */
    handleFormSubmit: function (formName) {
      let baseInfo = this.formData;

      if (!baseInfo.customerName) {
        this.$message.error("请输入姓名");
        return false;
      }
      if (!baseInfo.age) {
        this.$message.error("请输入年龄");
        return false;
      }
      if (baseInfo.birthday) {
        let age = COMMON.getAge(baseInfo.birthday);
        console.log(age);
        if (age != baseInfo.age) {
          this.$message.error("请输入正确的生日或年龄");
          return false;
        }
      }
      if (!baseInfo.mobile) {
        this.$message.error("请输入手机号");
        return false;
      }
      if (!baseInfo.serviceId) {
        this.$message.error("请选择预约项目");
        return false;
      }
      if (!baseInfo.price) {
        this.$message.error("请输入价格");
        return false;
      }
      if (!baseInfo.orderTime) {
        this.$message.error("请选择预约时间");
        return false;
      }
      if (!baseInfo.shopId) {
        this.$message.error("请选择预约门店");
        return false;
      }

      this.submitLoading = true;
      this.saveOrderInfo();
    },
    saveOrderInfo() {
      let formData = this.formData;

      let params = {
        // orderId: this.id,
        id: this.id,
        customerName: formData.customerName,
        sex: formData.sex,
        birthday: formData.birthday
          ? new Date(formData.birthday).getTime()
          : "",
        age: formData.age,
        mobile: formData.mobile,
        serviceId: formData.serviceId,
        price: formData.price,
        orderTime: formData.orderTime
          ? new Date(formData.orderTime).getTime()
          : "",
        shopId: formData.shopId,
        remark: formData.remark,
      };

      serviceOrdersUpdateOrderInfo(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.saveSchedule();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          this.$message.error("服务器异常");
        });
    },
    saveSchedule() {
      let formData = this.formData;

      let params = {
        orderId: parseFloat(this.id),
        id: formData.scheduleId || null,
        expectedSpending: formData.expectedSpending || null,
        passport: formData.passport || null,
        country: formData.country || null,
        flight: formData.flight || null,
        fromTime: formData.fromTime
          ? new Date(formData.fromTime).getTime()
          : null,
        toTime: formData.toTime ? new Date(formData.toTime).getTime() : null,
        hotel: formData.hotel || null,
        stayTime: formData.stayTime
          ? new Date(formData.stayTime).getTime()
          : null,
        needPickup: formData.needPickup || null,
        medicalExperience: formData.medicalExperience || null,
        diagnosisRecord: formData.diagnosisRecord || null,
        importantMatters: formData.importantMatters || null,
        specialRequirements: formData.specialRequirements || null,
      };

      serviceChatsAddSchedule(params)
        .then((res) => {
          this.submitLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message({ message: "保存成功", type: "success" });

            this.$router.push({
              path: "/service/reservation/list",
              query: { tabname: this.tabName },
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          this.$message.error("服务器异常");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.steps-bar {
  border-radius: 48px;
  overflow: hidden;
  background: $colorTitleBg;

  .steps-item {
    background: transparent;
    font-size: $baseFS;
    line-height: 48px;
    text-align: center;

    &.active {
      background: $themeColor;
      color: $colorWhite;
      border-radius: 48px;
    }
  }
}

.type-wrap {
  font-size: 0;
  text-align: left;

  .type-item {
    position: relative;
    display: inline-block;
    margin-left: 80px;
    padding: 10px 20px;
    border: 1px solid #dddddd;
    border-radius: 2px;
    cursor: pointer;

    & + .type-item {
      margin-left: 10px;
    }

    .label {
      font-size: 12px;
      line-height: 17px;
      color: #222;
    }

    .tips {
      margin-top: 4px;
      font-size: 12px;
      line-height: 17px;
      color: rgba(#222, 0.5);
    }

    &.active {
      border-color: $themeColor;

      .label {
        color: $themeColor;
      }

      &::before {
        content: "";
        @include position(absolute, 3, 0, 0, none, none);
        width: 16px;
        height: 16px;
        @include backgroundImage(
          "../../../assets/icon_16_2@2x.png",
          no-repeat,
          right,
          center,
          auto,
          16px
        );
      }
    }
  }
}

.radio-block {
  .tips {
    margin-left: 24px;
  }
}

.checkbox-block,
.switch-block {
  & + .checkbox-block,
  & + .switch-block {
    margin-left: 20px;
  }
}

.grey-inline-block {
  display: inline-block;
  background: $colorPageBg;
}

.paticular-table {
  background-color: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {
  }

  ::v-deep .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        background-color: transparent;

        td {
          padding: 5px 0;
          border-bottom-color: #ebeef5;
          /*border-bottom-color: transparent;*/
        }
      }
    }
  }
}

.pics-box {
  ::v-deep .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;
      transition: none;

      .el-upload-list__item-thumbnail {
        @include position(absolute, none, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
      }

      .el-progress {
        width: 80px;
        height: 80px;

        .el-progress-circle {
          width: 80px !important;
          height: 80px !important;
        }
      }

      .el-icon-close-tip {
        display: none;
      }

      .el-upload-list__item-actions {
        cursor: move;
      }
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;

      .el-icon-plus {
        font-size: $baseFS;
      }
    }
  }

  .video-box {
    .video-item {
      position: relative;
      width: 100px;
      height: 100px;

      .video {
        width: 98px;
        height: 98px;
        border: 1px solid #c0ccda;
      }

      .mask {
        @include position(absolute, 1, 0, 0, 0, 0);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background: rgba(#000, 0.5);
        opacity: 0;
        transition: opacity 0.3s;

        i {
          font-size: 20px;
          color: #fff;
          cursor: pointer;

          & + i {
            margin-left: 15px;
          }
        }
      }

      &:hover {
        .mask {
          opacity: 1;
          transition: opacity 0.3s;
        }
      }
    }
  }
}

// .pics-box-detail{
//     ::v-deep .el-upload-list{
//         .el-upload-list__item{
//             &.is-success{
//                 width: 500px;
//                 height: 200px;
//             }
//         }
//     }
// }

.particular-toolbar {
  padding: 8px 10px;
}

.sort-item {
  display: inline-block;
  padding: 0 12px;
  margin-right: 10px;
  line-height: 28px;
  white-space: nowrap;
  background-color: #eee;
  font-size: $smallFS;
  color: $textColor;
  border-radius: 2px;

  &:hover,
  &:focus {
    background-color: rgba(#5bcfe6, 0.2);
  }
}

.delete-block-category {
  margin-left: 70px;
  margin-bottom: 18px;

  .el-form-item {
    margin-left: -70px;
    margin-bottom: 0;

    & + .el-form-item {
      margin-top: 8px;
    }
  }
}

.specification-value-item {
  float: left;

  .specification-pics-box {
    position: relative;
    margin-bottom: 10px;

    .pics-box {
      width: 100px;
      height: 100px;
      overflow: hidden;
    }
  }
}

.select-loading {
  @include position(absolute, 10, 3px, 2px, 3px, 0);
  display: block;
  background: transparent;
  width: 100%;
  border: none;
  pointer-events: inherit;

  /*&::before{
            display: none;
        }*/

  &::after {
    border: none;
  }

  ::v-deep .el-icon-loading {
    color: $themeColor;
  }
}
</style>
